/**
 * Search_Service.ts
 * Catalog search (pgvector + full-text)  (sk-catalog-api GET /api/v1/search)
 */

import axiosInstance from '../../api/axiosInstance';
import { Catalog_Search_Url } from '../../api/endpoints';
import { SearchParams, SearchResponse } from '../../schemas/catalog/search';

/* ─────────────────────────────────────────
   Search — GET /api/v1/search?q=&locale=&limit=
   Hybrid full-text + vector similarity, tenant-scoped.
───────────────────────────────────────── */

export const searchItems = async (params: SearchParams): Promise<SearchResponse> => {
  const { data } = await axiosInstance.get<SearchResponse>(Catalog_Search_Url, { params });
  return data;
};
